import { useAppSelector } from "hooks/storeHooks"
import { useEffect, useState } from "react"
import { Outlet, useNavigate } from "react-router-dom"
import { Loader2 } from "lucide-react"

export const LoginPagesLayout: React.FC = () => {
  const navigate = useNavigate()
  const { username } = useAppSelector((state) => state.user.userInfo)
  const [isCheckingAuth, setIsCheckingAuth] = useState(true)

  useEffect(() => {
    setIsCheckingAuth(true)
    if (username) navigate("/home", { replace: true })

    setIsCheckingAuth(false)
  }, [username, navigate])

  return isCheckingAuth ? (
    <div className="flex h-screen w-screen items-center justify-center">
      <Loader2 className="h-6 w-6 animate-spin text-muted-foreground" />
    </div>
  ) : (
    <Outlet />
  )
}
